import React, { useState } from "react";
import { commonStyles, useRatingStyles } from "../styles";
import highlightImg from "../../../assets/images/mentor_profile/highlight.png";
import starImg from "../../../assets/images/startBrows.png";
import starEmptyImg from "../../../assets/images/emptyStar.png";

import feedbackIconGood from "../../../assets/images/feedback_icon_good.png";
import feedbackIconAverage from "../../../assets/images/feedback_icon_average.png";
import feedbackIconBad from "../../../assets/images/feedback_icon_bad.png";

export function Ratings({
  ratingData: data,
  feedbackRatings,
  getFeedbackRating,
  feedbackRatingLoading,
  ratingsLoading,
}) {
  const classes = useRatingStyles();
  const commonClasses = commonStyles();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    getFeedbackRating({
      params: {
        section: tabs[tabIndex]?.content,
        page: "1",
        limit: data?.summary?.total,
      },
    });
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <img
          key={i}
          src={i <= rating ? starImg : starEmptyImg}
          alt={i <= rating ? "filled star" : "empty star"}
          className={classes.star}
        />
      );
    }
    return stars;
  };

  const ratingData = [
    { rating: 5, count: data?.summary[5], color: "#16A34A" },
    { rating: 4, count: data?.summary[4], color: "#00B86B" },
    { rating: 3, count: data?.summary[3], color: "#E5A861" },
    { rating: 2, count: data?.summary[2], color: "#E9B935" },
    { rating: 1, count: data?.summary[1], color: "#E94D35" },
  ];

  const firstClassRating = {
    Good: feedbackIconGood,
    Bad: feedbackIconBad,
    Average: feedbackIconAverage,
  };

  const reviews = Object.values(feedbackRatings || {});

  const tabs = [
    { label: "Regular NPS Feedback", content: "regular" },
    { label: "First Class Feedback", content: "firstClass" },
    { label: "PTM Feedback", content: "ptm" },
  ];

  const maxCount = Math.max(...ratingData.map((item) => item.count));

  return (
    <div className={classes.ratings}>
      <h2 className={classes.title}>
        My{" "}
        <span className={classes.titleHighlight}>
          Ratings
          <img src={highlightImg} alt="" className={classes.titleHighlightImg} />
        </span>
        {" "}
      </h2>
      <div className={classes.container}>
        <div className={classes.ratingsSection}>
          <div className={classes.ratingOverview}>
            <div className={classes.ratingNumber}>
              {data?.summary?.ratings?.rated || 0}
            </div>
            <div className={classes.stars}>
              {renderStars(data?.summary?.ratings?.rated || 0)}
            </div>
            <div className={classes.reviewCount}>
              {data?.summary?.total || 0} Reviews
            </div>
          </div>

          <div className={classes.ratingBars}>
            {ratingData.map((item) => (
              <div key={item.rating} className={classes.ratingBar}>
                <span className={classes.ratingLabel}>{item.rating}</span>
                <div className={classes.progressBar}>
                  <div
                    className={classes.progress}
                    style={{
                      width:
                        maxCount === 0
                          ? 0
                          : `${(item.count / maxCount) * 100}%`,
                      backgroundColor: item.color,
                    }}
                  />
                </div>
                <span className={classes.ratingCount}>{item.count}</span>
              </div>
            ))}
          </div>
        </div>

        <div className={classes.tabs}>
          <div className={classes.tabsContainer}>
            <ul className={classes.tabsList}>
              {tabs.map((tab, index) => (
                <li
                  key={index}
                  className={`${classes.tab} ${
                    activeTab === index ? classes.tabActive : ""
                  }`}
                  onClick={() => handleTabChange(index)}
                >
                  {tab.label}{" "}
                  {!!data?.summary?.feedbackCount?.[tabs[index].content] && (
                    <span className={classes.count}>
                      {data?.summary?.feedbackCount[tabs[index].content]}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div className={classes.tabContent}>
            <div>
              {feedbackRatingLoading ? (
                [1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className={classes.reviewCard}
                    style={{ display: "flex", flexDirection: "column", gap: 10 }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <div className={classes.shimmerBlock} style={{ width: 110, height: 14, borderRadius: 4 }} />
                      <div className={classes.shimmerBlock} style={{ width: 80, height: 14, borderRadius: 4 }} />
                    </div>
                    <div className={classes.shimmerBlock} style={{ width: 90, height: 16, borderRadius: 4 }} />
                    <div className={classes.shimmerBlock} style={{ width: "90%", height: 12, borderRadius: 4 }} />
                    <div className={classes.shimmerBlock} style={{ width: "70%", height: 12, borderRadius: 4 }} />
                  </div>
                ))
              ) : (
                reviews?.length === 0 && <div>No feedback available</div>
              )}

              {!feedbackRatingLoading &&
                reviews?.length > 0 &&
                reviews?.map((review, index) => (
                  <div
                    key={index}
                    className={`${classes.reviewCard} ${
                      index === reviews.length - 1 ? classes.reviewCardLast : ""
                    }`}
                  >
                    <div className={classes.reviewHeader}>
                      <span className={classes.parentName}>
                        {review.parentName}
                      </span>
                      <span className={classes.reviewDate}>{review.date}</span>
                    </div>
                    <div className={classes.reviewStars}>
                      {activeTab === 1 ? (
                        <div
                          className={`${classes.chipBase} ${
                            classes[review.overallRating?.rated]
                          }`}
                        >
                          {review.overallRating?.rated}
                          <img
                            src={firstClassRating[review.overallRating?.rated]}
                            alt="Good"
                            className={classes.icon}
                          />
                        </div>
                      ) : (
                        renderStars(review.overallRating?.rated)
                      )}
                    </div>
                    {review.feedback && (
                      <div className={classes.reviewText}>
                        {review.feedback}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
